import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Trash2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { http, formatApiError } from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Panel } from "@/components/admin/PageBits";

export const BlocksTable = ({ onBlockIp }) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => http.get("/admin/security/blocks").then(({ data }) => setRows(data)).catch((e) => toast.error(formatApiError(e))), []);
  useEffect(() => { load(); }, [load]);
  const clear = async () => {
    try { await http.delete("/admin/security/blocks"); setRows([]); toast.success("Registro de bloqueios limpo."); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const action = (
    <div className="flex gap-2">
      <button onClick={load} className="btn-ghost-sm" data-testid="blocks-refresh-btn"><RefreshCw className="h-3.5 w-3.5" /> Atualizar</button>
      <button onClick={clear} disabled={!rows.length} className="btn-ghost-sm" data-testid="blocks-clear-btn"><Trash2 className="h-3.5 w-3.5" /> Limpar</button>
    </div>
  );
  return (
    <Panel title="Acessos bloqueados" action={action} testId="blocks-panel">
      {!rows.length ? <p className="text-sm text-slate-500" data-testid="blocks-empty">Nenhum acesso bloqueado até agora.</p> : (
        <div className="overflow-x-auto">
          <Table data-testid="blocks-table">
            <TableHeader>
              <TableRow className="border-white/[0.06] hover:bg-transparent">
                {["Último acesso", "IP", "País", "Motivo", "Tentativas", "Navegador", ""].map((h) => <TableHead key={h} className="text-xs uppercase tracking-wider text-slate-500">{h}</TableHead>)}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id} className="border-white/[0.04]" data-testid={`block-row-${r.id}`}>
                  <TableCell className="whitespace-nowrap text-sm text-slate-400">{formatDateTime(r.last_at)}</TableCell>
                  <TableCell className="font-mono-x text-sm">{r.ip}</TableCell>
                  <TableCell className="text-sm">{r.country || "—"}</TableCell>
                  <TableCell className="text-sm">{r.reason}</TableCell>
                  <TableCell className="text-sm">{r.count}</TableCell>
                  <TableCell className="max-w-[260px] truncate text-xs text-slate-500" title={r.user_agent}>{r.user_agent || "—"}</TableCell>
                  <TableCell>
                    {r.reason !== "IP bloqueado manualmente" && <button onClick={() => onBlockIp(r.ip)} className="btn-ghost-sm" data-testid={`block-add-ip-${r.id}`}>Bloquear sempre</button>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </Panel>
  );
};
